class AnnouncementBar extends HTMLElement {
      
      constructor() {
        super();
      }
  
      connectedCallback() {
          this.announcement = document.querySelector('.section-header-announcement-bar');
        
         if (this.classList.contains('announcement-bar-sticky')) {
            this.announcement.classList.add('shopify-section-announcement-bar-sticky');
         };
      }
}

        

customElements.define('announcement-bar-component', AnnouncementBar);